import { render } from "./SoccerForm.vue?vue&type=template&id=1d9a0785&scoped=true&ts=true"
import script from "./SoccerForm.vue?vue&type=script&lang=ts"
export * from "./SoccerForm.vue?vue&type=script&lang=ts"

import "./SoccerForm.vue?vue&type=style&index=0&id=1d9a0785&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d9a0785"]])

export default __exports__